import { type AnagraficaDTO } from '@framework/api-client/api/inquiries/schemas/anagraficaDTO.ts';

/**
 * Converte i valori di Anagrafica in un oggetto chiave-valore.
 */
export function parseRegistersToContext(
  registers: AnagraficaDTO[] | null | undefined,
) {
  // Creo un oggetto con chiave il nome del registro e valore un array di codici
  // dei valori del registro.
  // Es:
  // {
  //   "Registro1": ["codice1", "codice2"],
  //   "Registro2": ["codice3", "codice4"],
  //   ...
  // }
  return (
    registers?.reduce((acc: Record<string, any[]>, reg) => {
      if (!reg.nome) {
        console.warn('Nome registro non specificato', reg);
        return acc;
      }

      acc[reg.nome] =
        reg.valori?.map(v => {
          switch (reg.tipo) {
            case 'NUMBER':
              return Number(v.codice);
            case 'STRING':
            default:
              return v.codice;
          }
        }) ?? [];

      return acc;
    }, {}) ?? {}
  );
}
